import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "button-group" }
const _hoisted_2 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.value,
        class: _normalizeClass(["option pointer", {active: _ctx.value === option.value}]),
        onClick: $event => (_ctx.value = option.value)
      }, [
        (_ctx.$slots.option)
          ? _renderSlot(_ctx.$slots, "option", {
              key: 0,
              option: option
            }, undefined, true)
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(option.title), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ], 10 /* CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}